module.exports = __webpack_public_path__ + "img/wist_kawaiievgame.ebf29d1.png";